<template>
  <div class="w-full">
    <froala
        id="edit"
        v-model="editorContent"
        :config="config"
        dir="ltr"
    ></froala>
  </div>
</template>

<script>
import mainBaseUrl from "@/global-components";
import {getUserData} from "@/auth/utils";

export default {
  emits: ["getEditorContent"],
  props: {
    defaultEditorContent: {
      required: false,
    },
  },
  mounted() {
    if (this.defaultEditorContent) {
      setTimeout(() => {
        this.editorContent = this.defaultEditorContent;
      }, 300)
    }
  },
  watch: {
    editorContent: {
      handler(val) {
        this.$emit("getEditorContent", val);
      },
    },
  },

  computed: {
    baseUrl() {
      return process.env.base
    }
  },
  data() {
    return {
      config: {
        videoUpload: true,
        videoUploadURL: `${mainBaseUrl}api/Upload`,
        videoUploadParams: {
          ObjectId: -1,
          type: 8,
          mediaType: 30,
          alt: "",
        },
        videoUploadParam: "file",
        imageUpload: true,
        toolbarSticky: true,
        imageUploadURL: `${mainBaseUrl}api/Upload`,
        attribution: false,
        imageUploadParams: {
          ObjectId: -1,
          type: 8,
          mediaType: 30,
          alt: "",
        },
        imageUploadParam: "file",
        requestHeaders: {
          Authorization: getUserData().token,
        },
      },
      editorContent: null,
    };
  },
};
</script>

<style lang="scss">
.fr-view {
  height: 30rem;
}
</style>
